import { AlertCircle } from 'lucide-react';
import { apiFetch } from '@/lib/api-client';
import { useAuthStore } from '@/stores/authStore';
import { STRINGS } from '@/strings/strings';

export function EmailVerificationBanner() {
  const emailVerified = useAuthStore((s) => s.user?.emailVerified ?? true);

  if (emailVerified) return null;

  const handleResend = async () => {
    try {
      await apiFetch('/api/auth/request-verification', {
        method: 'POST',
        body: {},
      });
    } catch (err) {
      // 400 ("already verified"): stale state, resolves on next /me hydrate.
      // Network / 5xx: silent, user retries. Don't crash the banner.
      console.error('[EmailBanner] resend failed:', err);
    }
  };

  return (
    <div className="flex items-center gap-2.5 px-4 py-2.5 bg-[rgba(255,201,77,0.15)] border-b border-[rgba(255,201,77,0.3)]">
      <AlertCircle className="w-4 h-4 text-[color:var(--color-warning-icon)] shrink-0" />
      <p className="flex-1 text-[12px] leading-[1.4] text-[color:var(--color-warning-text)]">
        {STRINGS.shell.emailBanner.text}
      </p>
      <button
        type="button"
        onClick={handleResend}
        className="shrink-0 px-3 py-1.5 rounded-md bg-dream-navy text-dream-white text-[11px] font-medium whitespace-nowrap"
      >
        {STRINGS.shell.emailBanner.cta}
      </button>
    </div>
  );
}
